import toast from 'react-hot-toast';
import {
  obtenerCorreo,
  obtenerCorreoOlvidoContraseña,
} from '../../Services/ForgetPassword';
import { Dispatch, SetStateAction } from 'react';

export type funcionCorreoType = 'recuperar' | 'cambiar';

export function obtenerCorreoCambiarContraseña(
  email: string,
  tipo: funcionCorreoType,
  setLoading: Dispatch<SetStateAction<boolean>>,
  setModalAfterVerification: Dispatch<SetStateAction<boolean>>,
  setUsuarioTestAsesoriaID: Dispatch<SetStateAction<number>>,
) {
  switch (tipo) {
    case 'recuperar':
      obtenerCorreoOlvidoContraseña({
        Correo: email,
      })
        .then((_response) => {
          toast.success(
            '¡Listo, hemos enviado tu contraseña al WhatssApp asociado a tu cuenta 😀!',
          );
        })
        .catch((_error) => {
          toast.error('No se ha podido enviar el correo, por favor intenta de nuevo');
        })
        .finally(() => {
          setLoading(false);
        });

      break;
    case 'cambiar':
      obtenerCorreo({
        Correo: email,
      })
        .then((response) => {
          setModalAfterVerification(true);
          setUsuarioTestAsesoriaID(response.data.data.usuarioTestAsesoriaID);
          setLoading(false);
        })
        .catch(() => {
          toast.error('No se ha podido enviar el correo, por favor intenta de nuevo');
          setLoading(false);
        });

      break;    
    default:
      break;
  }
}
